import { render, staticRenderFns } from "./PrivilegeHistoryNewLayout.vue?vue&type=template&id=97e75664&scoped=true"
import script from "./PrivilegeHistoryNewLayout.vue?vue&type=script&lang=js"
export * from "./PrivilegeHistoryNewLayout.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeHistoryNewLayout.vue?vue&type=style&index=0&id=97e75664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e75664",
  null
  
)

export default component.exports